module.exports = __webpack_public_path__ + "img/elconfidencial.165714a8.svg";